<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Payout Records</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source">
          <option *ngFor="let source of sourceList | keyvalue" [ngValue]="source.value">{{source.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country">
          <option *ngFor="let country of countryList | keyvalue" [ngValue]="country.value">{{country.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator">
          <option *ngFor="let operator of operatorList" [ngValue]="operator">{{operator}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by MT Year</u></label>
        <select [(ngModel)]="filterable.mtYear" class="form-control" placeholder="MT Year">
          <option *ngFor="let year of yearList" [ngValue]="year">{{year}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by MT Month</u></label>
        <select [(ngModel)]="filterable.mtMonth" class="form-control" placeholder="MT Month">
          <option *ngFor="let month of monthList" [ngValue]="month.value">{{month.name}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><u>Filter by ShortCode</u></label>
        <input type="text" [(ngModel)]="filterable.shortCode" class="form-control" placeholder="Enter ShortCode" />
      </div>
      <div class="col">
        <label for=""><u>Filter by Keyword</u></label>
        <input type="text" [(ngModel)]="filterable.keyword" class="form-control" placeholder="Enter Keyword" />
      </div>
      <div class="col">
        <label for=""><u>Filter by Client</u></label>
        <input type="text" [(ngModel)]="filterable.account" class="form-control" placeholder="Enter Account" />
      </div>
      <div class="col">
        <label for=""><u>Filter by Payout Year</u></label>
        <select [(ngModel)]="filterable.payoutYear" class="form-control" placeholder="Payout Year">
          <option value=null >-- select year --</option>
          <option *ngFor="let year of yearList" [ngValue]="year">{{year}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Payout Month</u></label>
        <select [(ngModel)]="filterable.payoutMonth" class="form-control" placeholder="Payout Month">
          <option value=null >-- select month --</option>
          <option *ngFor="let month of monthList" [ngValue]="month.value">{{month.name}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <div class="col text-right align-self-end">
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
</div>
</div>
<!-- <div class="table-responsive"> -->
<table id="moList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>MT Month</th>
      <th>Payout Month</th>
      <th>Operator</th>
      <th>ShortCode</th>
      <th>Keyword</th>
      <th>Account</th>
      <th>Price</th>
      <th>Suppose MT</th>
      <th>Payout MT</th>
      <th>Refund</th>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="12">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="12">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let record of records; index as i;">
      <td>{{record.mtMonth}}</td>
      <td>{{record.payoutMonth}}</td>
      <td>{{record.operator}}</td>
      <td>{{record.shortCode}}</td>
      <td>{{record.keyword}}</td>
      <td nowrap>{{record.account}}</td>
      <td class="text-right">{{record.price}}</td>
      <td class="text-right">{{record.supposeMt}}</td>
      <td class="text-right">{{record.payoutMt}}</td>
      <td class="text-right">{{record.refund}}</td>
      <td>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteRecord(record)" >
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="12" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
      </td>
    </tr>
  </tfoot>
</table>
